import { makeStyles } from "@mui/styles";
import { primaryColor } from "../../../../constants/colors";

const orderStyle = makeStyles((theme) => ({
  loginBtn: {
    "&.MuiButton-root": {
      backgroundColor: primaryColor,
      width: "100%",
      padding: "6px",
      "&:hover": {
        backgroundColor: "#e21b70",
      },
    },
  },
  loginBtnText: {
    fontSize: "15px !important",
    textTransform: "none",
    fontWeight: "500 !important",
  },
}));

export default orderStyle;
